import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RenamePlaylistTagDocument } from './rename.generated';

const useRename = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();

  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.playlist_tags.rename_error'),
      success: t('api.playlist_tags.rename_success'),
    }),
    ...options,
  });
};

export const useRenamePlaylistTag = (options: ApiOptions<typeof RenamePlaylistTagDocument> = {}) =>
  useRename(RenamePlaylistTagDocument, options);
